import { inject, Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class MetaService {
  private meta = inject(Meta);
  private title = inject(Title);

  private titles = {
    learn: "Sporty's Pilot Training Courses",
    learnToFly: "Welcome to Sporty's Learn To Fly Course",
    faaTestReport: 'FAA Knowledge Test ACS Codes Lookup Tool',
    acsCodes: 'FAA Knowledge Test ACS Codes'
  };

  private tags = {
    learn: [
      {
        name: 'keywords',
        content: 'online ground school, flight training, pilot license'
      },
      {
        name: 'description',
        content:
          'Modern flight training for modern pilots. Nine platforms, one price. Automatic written test endorsements. Dynamic in-flight video. FREE lifetime updates.'
      }
    ],
    learnToFly: [
      {
        name: 'keywords',
        content:
          'online ground school, flight training, private pilot license, FAR, test prep'
      },
      {
        name: 'description',
        content:
          "Ace your FAA written test, save money during flight training, and become a better pilot with Sporty's Learn To Fly Course."
      }
    ],
    faaTestReport: [
      {
        name: 'keywords',
        content:
          'acs codes, plt codes, FAA Written Test Codes Lookup, FAA Written Test Codes, AI, machine learning'
      },
      {
        name: 'description',
        content:
          'Use Aviation Intelligence by Sporty’s to analyze your test results and look up ACS Codes for Private, Instrument, and Commercial Knowledge.'
      }
    ],
    acsCodes: [
      {
        name: 'keywords',
        content:
          'acs codes, plt codes, FAA Written Test Codes Lookup, FAA Written Test Codes'
      },
      {
        name: 'description',
        content:
          'This page includes all of the ACS knowledge codes for Private, Instrument and Commercial pilot tests.'
      }
    ]
  };

  addMetaTags(path: 'learn' | 'learnToFly' | 'faaTestReport' | 'acsCodes') {
    this.meta.removeTag("name='robots'");
    this.meta.addTag({ name: 'robots', content: 'index, follow' });
    this.title.setTitle(this.titles[path]);
    this.meta.addTags(this.tags[path]);
  }

  removeMetaTags() {
    this.meta.removeTag("name='robots'");
    this.title.setTitle("Sporty's Online Training");
    this.meta.removeTag('name="keywords"');
    this.meta.removeTag('name="description"');
  }
}
